import Amplify from 'aws-amplify';
import config from './awsExports';

Amplify.configure(config);
